<template>
    <MdField
        @click="emitClick()"
        :class="classes"
    >
        <label v-if="label">{{ label }}</label>
        <MdSelect
            ref="select"
            :value="value"
            :name="name"
            :multiple="multiple"
            @md-selected="$emit('update', $event)">
            <template v-for="item in items">
                <MdOption v-if="item.validator === undefined || item.validator" :value="item.value" :key="item.value">
                    {{ item.label }}
                </MdOption>
            </template>
        </MdSelect>
        <span class="md-error" v-if="error">{{ error }}</span>
        <i class="far fa-chevron-down"></i>
    </MdField>
</template>

<script>
export default {
  name: 'IoBaseSelect',
  model: {
    prop: 'value',
    event: 'update',
  },
  data() {
    return {
      selectRef: null,
    };
  },
  props: {
    value: {
      required: true,
      type: [Number, String, Boolean, Array],
    },
    items: {
      required: true,
      type: Array,
      default: () => ([
        {
          value: '',
          label: '',
        },
      ]),
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      required: true,
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      validator(value) {
        return ['', 's', 'xs'].indexOf(value) !== -1;
      },
      default: '',
    },
  },
  mounted() {
    this.selectRef = this.$refs.select;
  },
  computed: {
    classes() {
      return {
        select: true,
        'md-invalid': this.error,
        [`md-field--${this.size}`]: this.size,
        outlined: this.outlined,
        rounded: this.rounded,
      };
    },
  },
  methods: {
    emitClick() {
      this.selectRef.click();
    },
  },
};
</script>

<style lang="scss" scoped>

.md-field {
    margin: 0;
    cursor: pointer;
    width: 100%;
    min-height: 48px;
    margin: 0;
    padding-top: 16px;
    display: flex;
    position: relative;
    font-family: inherit;
    height: 65px;
    padding: 20px 32px 0 32px;

    :deep(&) {
        & .md-menu.md-select .md-input-fake,
        & .md-menu.md-select select {
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            overflow: hidden;
            position: absolute;
            clip: rect(0 0 0 0);
            border: 0;
        }

        & .md-input {
            height: 32px;
            padding: 0;
            outline: none;
            cursor: pointer;
            display: block;
            flex: 1;
            border: none;
            background: none;
            transition: .4s cubic-bezier(.25,.8,.25,1);
            transition-property: font-size,padding-top,color;
            font-family: inherit;
            font-size: 16px;
            line-height: 32px;
        }

        & .md-menu .md-icon {
            display: none;
        }
    }

    .md-menu.md-select {
        display: flex;
        flex: 1;
        overflow: auto;

        & .md-input {
            flex: 1;
            min-width: 0;
        }

        &:not(.md-disabled) .md-input {
            cursor: pointer;
            outline: none;
        }
    }

    &.rounded {
        border-radius: 9999px !important;
    }

    label {
        position: absolute;
        line-height: 20px;
        top: 4px;
        transform: translateY(0%);
        transition: all 0.225s ease-out;
        left: 32px;
        font-weight: 400;
        margin-bottom: 0;
    }

    &.outlined {
        border: 1px solid #dee2e6;

        select {
            height: auto;
            min-height: 65px;
        }

        &.md-focused label,
        &.md-has-value label {
            pointer-events: auto;
            opacity: 1;
            font-size: 12px;
            top: 4px;
            transform: translateY(0%);
        }
    }

    &--s {
        padding: 16px 26px 0 26px;
        height: 3.5rem;
        font-size: 1rem;

        label {
            top: 14px;
            left: 26px;
        }

        &:focus,
        &:focus-within,
        &.value {
            label {
                top: 6px;
                font-size: 12px;
            }
        }
    }

    &--xs {
        padding: 16px 22px 0 22px;
        height: 3rem;
        font-size: 1rem;

        label {
            top: 10px;
            left: 22px;
        }

        &:focus,
        &:focus-within,
        &.value {
            label {
                top: 4px;
                font-size: 12px;
            }
        }
    }
}

.select--icon {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    padding-right: 5px;
    border-left: 1px solid #dee2e6;
}
</style>
